/* eslint-disable max-lines */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/_sidebar-layout/')({
  beforeLoad: function ({ search }) {
    // eslint-disable-next-line no-throw-literal, @typescript-eslint/only-throw-error
    throw redirect({ to: '/app/blogs', search });
  },
  // eslint-disable-next-line no-use-before-define
  component: Index,
});

function Index() {
  return <div className="h-full flex-1 overflow-y-scroll pb-20 pt-12"></div>;
}
